import { useEffect, useState } from 'react'

import { Mode } from 'theme/constants'
import { getSystemColorScheme, getSystemColorSchemeMatch } from 'theme/utils'

/**
 * Access the preferred system/browser theme variant (light/dark).
 */
export function useSystemThemeVariant(): Mode {
  const [colorScheme, setColorScheme] = useState<Mode>(getSystemColorScheme())

  useEffect(() => {
    const mediaMatch = getSystemColorSchemeMatch()

    const listener = (event: MediaQueryListEvent): void => {
      setColorScheme(event.matches ? Mode.DARK : Mode.LIGHT)
    }

    mediaMatch.addEventListener('change', listener)

    return () => {
      mediaMatch.removeEventListener('change', listener)
    }
  }, [])

  return colorScheme
}
